import store from '../store'

export const moneda=(value,numDecimales=0)=>{
  const fixed = value.toFixed(numDecimales);
  const formated = fixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "|");
  const formated2 = formated.replace(/\./g, ',');
  

    return 'IU'+formated2
}